module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}


//////////////////
// WEBPACK FOOTER
// ../~/html-to-react/~/entities/lib/maps/xml.json
// module id = 208
// module chunks = 26